import { ContactCell } from '../Shared/TableCells/ContactCell.js';

export function ChannelPageTableKeyCell({...params}){
    let keyName = params.id
    if (keyName !== 'Contact') return keyName
    else return <ContactCell contacts={params.row.fieldValue} callSign={params.callSign} affiliate={params.affiliate}></ContactCell>
}
